// Swiper
const swiper01 = new Swiper('.swiper', {
  effect: 'slide',
  slidesPerView: 1.5, // コンテナ内に表示させるスライド数（CSSでサイズ指定する場合は 'auto'）
  spaceBetween: 24, // スライド間の余白（px）
  // centeredSlides: true, // アクティブなスライドを中央に配置する
  // loop: true,  // 無限ループさせる
  // loopAdditionalSlides: 1, // 無限ループさせる場合に複製するスライド数
  // speed: 300, // スライドアニメーションのスピード（ミリ秒）

  grabCursor: true, // PCでマウスカーソルを「掴む」マークにする
  watchSlidesProgress: true, // スライドの進行状況を監視する
  keyboard: true,
  // mousewheel: true,

  navigation: {
    nextEl: '.swiper-button-next', // 「次へ」ボタン要素のクラス
    prevEl: '.swiper-button-prev', // 「前へ」ボタン要素のクラス
  },

  breakpoints: { // ブレークポイント
    768: { // 画面幅768px以上で適用
      slidesPerView: 4,
      spaceBetween: 40,
    }
  }

});
